export default {
  name: "menuTopbar"
};